import React from 'react';

export default function IconTrash() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      fill="none"
      viewBox="0 0 12 12"
    >
      <path
        d="M5 3h2a1 1 0 00-2 0zM4 3a2 2 0 114 0h2.5a.5.5 0 010 1h-.441l-.443 5.17A2 2 0 017.623 11H4.377a2 2 0 01-1.993-1.83L1.941 4H1.5a.5.5 0 110-1H4zm3.5 3a.5.5 0 10-1 0v2a.5.5 0 101 0V6zM5 5.5a.5.5 0 01.5.5v2a.5.5 0 11-1 0V6a.5.5 0 01.5-.5zM3.38 9.085a1 1 0 00.997.915h3.246a1 1 0 00.996-.915L9.055 4h-6.11l.435 5.085z"
      ></path>
    </svg>
  );
}